import React, { useState, useEffect } from 'react';
import axios from "axios";
import ReactPaginate from "react-paginate";
import "../../App.css";
import "./Dashboard.css";

const ContactController = () => {

    const [contacts, setContacts] = useState([]);
    const [contact, setContact] = useState({
        name: "",
        email: "",
        phone: ""
    });
    const [loading, setLoading] = useState(true);
    const [selectedIds, setSelectedIds] = useState([]);
    const [checkAll, setCheckAll] = useState(false);
    const [currentPage, setCurrentPage] = useState(0);
    const [itemsPerPage, setItemsPerPage] = useState(5);


    // データの取り出し
    useEffect(() => {
        const fetchContacts = async () => {
            try {
                setLoading(true);
                const response = await axios.get("http://127.0.0.1:8000/api/contacts");
                setContacts(response.data);
            } catch (error) {
                console.error("データ取得エラー", error);
                // setLoading(false);
            } finally {
                setLoading(false);
            }
        }
        fetchContacts();
        console.log('selectedIds:', selectedIds);
    }, []);

    // データの削除
    const handleDelete = async (id) => {
        try {
            await axios.delete(`http://localhost:8000/api/contacts/${id}`);

            setContacts(contacts.filter((contact) => contact.id !== id));
            //     これはフロントエンドでの配列操作に基づいて描画している

            const response = await axios.get("http://localhost:8000/api/contacts");
            setContacts(response.data);

        } catch (error) {
            console.error("削除エラーです。", error);
            console.log("id" + id);
        }
    }
    // 一括削除の関数
    const handleDeleteAll = async () => {
        try {
            await axios.delete("http://localhost:8000/api/contacts", {
                data: { ids: selectedIds }
            });

            setContacts(contacts.filter(contact => !selectedIds.includes(contact.id)));
            setSelectedIds([]);
        } catch (error) {
            console.error("一括削除エラーです。", error);
        }
    }

    const handleCheckboxChange = (id) => {
        setSelectedIds((prevSelected) => {
            return prevSelected.includes(id)
                ? prevSelected.filter((selectedId) => selectedId !== id)
                : [...prevSelected, id]
        });
    };

    useEffect(() => {
        console.log('selectedIds:', selectedIds);
    }, [selectedIds]);


    const handleCheck = () => {
        if (checkAll) {
            // 選択を解除する場合、現在のページに表示されているIDを除外
            setSelectedIds((prevSelected) =>
                Array.isArray(prevSelected)
                    ? prevSelected.filter((id) => !currentItems.some((item) => item.id === id))
                    : []
            );
        } else {
            // 選択する場合、現在のページに表示されているIDを追加
            setSelectedIds((prevSelected) => [
                ...(Array.isArray(prevSelected) ? prevSelected : []),
                ...currentItems.map((item) => item.id).filter((id) => !prevSelected.includes(id)),
            ]);
        }
    
        setCheckAll(!checkAll); // チェック状態を反転
    };
    


    // Pagination

    // 現在のページのデータを計算
    const offset = currentPage * itemsPerPage; // 現在のページの開始位置
    const currentItems = contacts.slice(offset, offset + itemsPerPage); // 現在のページに表示するデータ

    // ページ切り替え時の処理
    const handlePageChange = ({ selected }) => {
        setCurrentPage(selected); // 選択されたページ番号を更新
    };

    // 時間のフォーマッター
    const formatTimestamp = (timestamp) => {
        const date = new Date(timestamp);
        return date.toLocaleString();
    }

    const handleDeleteVisible = async () => {
        try {
            const visibleIds = currentItems.map((item) => item.id);
            await axios.delete("http://localhost:8000/api/contacts", {
                data: { ids: visibleIds }
            });

            setContacts(contacts.filter((contact) => !visibleIds.includes(contact.id)));

            setSelectedIds((prev) => prev.filter((id) => !visibleIds.includes(id)));

        } catch (error) {
            console.error("可視アイテム削除エラー", error);
        }
    }

    if (loading) {
        return (
            <div>
                Now Loading...
            </div>
        );
    }


    return (
        <div className="dashboard-contents-wrapper">
            
            <table>
                <thead>
                    <th>
                        <input
                            type="checkbox"
                            onChange={handleCheck}
                        />

                    </th>
                    <th>ID</th>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Title</th>
                    <th>Message</th>
                    <th>Created at</th>
                </thead>

                <tbody>
                    {currentItems.map((contact) => (
                        <tr key={contact.id}>
                            <td>
                                <input
                                    type="checkbox"
                                    checked={Array.isArray(selectedIds) && selectedIds.includes(contact.id)}
                                    onChange={() => handleCheckboxChange(contact.id)}
                                // {checkAll ? "checked" : ""}
                                />
                            </td>
                            <td>{contact.id}</td>
                            <td>{contact.name}</td>
                            <td><a href={"mailto:" + contact.email}>{contact.email}</a></td>
                            <td>{contact.title}</td>
                            <td>{contact.message}</td>
                            <td>{formatTimestamp(contact.created_at)}</td>
                            <td>
                                <button onClick={() => handleDelete(contact.id)}>削除</button>
                            </td>

                        </tr>
                    )

                    )}

                </tbody>




            </table>

            <ReactPaginate
                previousLabel={"<"} // 前のページボタン
                nextLabel={">"} // 次のページボタン
                breakLabel={"..."} // ページが多い場合の区切り
                pageCount={Math.ceil(contacts.length / itemsPerPage)} // 総ページ数
                marginPagesDisplayed={2} // 最初と最後に表示するページ数
                pageRangeDisplayed={3} // 現在ページの周囲に表示するページ数
                onPageChange={handlePageChange} // ページ切り替え時の処理
                containerClassName={"pagination"} // ページネーション全体のクラス名
                activeClassName={"active"} // 現在ページのクラス名
            />



            <button onClick={handleDeleteAll}>選択された項目を一括削除</button>
            <select onChange={
                (e) => {
                    setItemsPerPage(Number(e.target.value));
                    setCurrentPage(0);
                }}>
                <option value="5">5</option>
                <option value="10">10</option>
                <option value="20">20</option>
                <option value={contacts.length}>全件表示（{contacts.length}）</option>
            </select>

        </div>
    )
}
export default ContactController;